module.exports = __webpack_public_path__ + "static/media/2025_Rambøll_Grønland_A_S.8ddac216.png";